import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Table, Paragraph } from '@zillow/constellation';
import React from 'react';
import MortgageRatesTableModal from './MortgageRatesTableModal.js';

var _excluded = ["children"];
var MortgageRatesTableContainer = function MortgageRatesTableContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table.Responsive, null, /*#__PURE__*/React.createElement(Table, {
    appearance: "horizontal",
    "aria-label": "Medium-sized zebra table",
    size: "md"
  }, children)), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "legal",
    padding: "sm"
  }, "Last updated ", props === null || props === void 0 ? void 0 : props.updatedAt, ".", ' ', /*#__PURE__*/React.createElement(MortgageRatesTableModal, props)));
};
var MortgageRatesTableContainer$1 = MortgageRatesTableContainer;

export { MortgageRatesTableContainer$1 as default };
